<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <div>
          <h1>{{ 'ApPaymentRequests_Title' | translateWF: 'AP Payment Requests' }}</h1>
          <p class="page__subtitle">
            {{
              'ApPaymentRequests_Subtitle'
                | translateWF
                  : 'Select invoices for a provider and
            submit for approval.'
            }}
          </p>
        </div>
        <div class="page__title_buttons">
          <p-button [label]="'ApPaymentRequests_New' | translateWF: 'New request'" icon="pi pi-plus" (click)="redirectToDetails('new')" />
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <div>
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'ApPaymentRequests_Title' | translateWF: 'AP Payment Requests'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="requests()" selectionMode="single" [lazy]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'ApPaymentRequest_Number' | translateWF: 'Request #' }}</th>
                <th>{{ 'ApPayment_Provider' | translateWF: 'Provider' }}</th>
                <th>{{ 'ApPayment_Invoices' | translateWF: 'Invoices' }}</th>
                <th class="text-right">{{ 'ApPaymentRequest_Total' | translateWF: 'Total' }}</th>
                <th>{{ 'Status' | translateWF: 'Status' }}</th>
                <th>{{ 'ApPaymentRequest_Payment' | translateWF: 'Payment' }}</th>
                <th>{{ 'ApPaymentRequest_Created' | translateWF: 'Created' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let request = getRowData(rowData);
              <tr>
                <td>
                  <a class="cs-table-link" (click)="redirectToDetails(request.id ?? undefined)">{{ request.number }}</a>
                </td>
                <td>{{ request.providerLegalName || request.providerCode }}</td>
                <!-- A request can pay many invoices: the first is named, the rest counted, all in the tooltip. -->
                <td>
                  @let invoices = invoiceNumbers(request);
                  @if (invoices.length === 0) {
                    <span class="text-surface-500">—</span>
                  } @else {
                    <span [pTooltip]="invoices.join(', ')" tooltipPosition="top">{{ invoices[0] }}</span>
                    @if (invoices.length > 1) {
                      <span class="text-surface-500 ml-1">+{{ invoices.length - 1 }}</span>
                    }
                  }
                </td>
                <td class="text-right">{{ request.totalAmount | number: '1.2-2' }} {{ currencyLabel(request.currency) }}</td>
                <td>
                  <p-tag [severity]="statusSeverity(request.status)" [value]="statusLabel(request.status)" />
                </td>
                <td>
                  @if (request.spawnedApPaymentReference) {
                    <i class="pi pi-check-circle text-green-500" [pTooltip]="'ApPaymentRequest_HasPayment' | translateWF: 'Draft payment created'"></i>
                  } @else {
                    <span class="text-surface-400">—</span>
                  }
                </td>
                <td>{{ request.createdDate | date: 'dd/MM/yyyy' }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">{{ 'ApPaymentRequests_NotFound' | translateWF: 'No payment requests found' }}</td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
